export default __webpack_public_path__ + "static/media/image-7.fb84d0a3.png";